// Every possibility to draw the competences, vectors and dimensions in the radar is here
export const coordinates = {
  0: {
    competences: [
      { x: 178.488, y: 68.446, xText: 175.908, yText: 71.0708 },
      { x: 179.356, y: 63.521, xText: 177.928, yText: 66.1465 },
      { x: 180.225, y: 58.598, xText: 178.016, yText: 61.2222 },
      { x: 181.093, y: 53.673, xText: 178.926, yText: 56.2983 },
      { x: 181.961, y: 48.749, xText: 178.817, yText: 51.374 },
      { x: 182.829, y: 43.825, xText: 180.659, yText: 46.4497 },
      { x: 183.697, y: 38.9, xText: 181.373, yText: 41.5259 },
      { x: 184.566, y: 33.977, xText: 182.442, yText: 36.6016 },
      { x: 185.435, y: 29.052, xText: 183.049, yText: 31.6772 },
      { x: 186.303, y: 24.128, xText: 183.98, yText: 26.7529 },
      { x: 187.171, y: 19.204, xText: 183.162, yText: 21.8286 },
      { x: 188.039, y: 14.28, xText: 185.182, yText: 16.9048 },
      { x: 188.907, y: 9.355, xText: 185.27, yText: 11.9805 },
    ],
    vectors: [
      { x: 193.243, y: 107.871, xText: 190.662, yText: 110.496 },
      { x: 194.493, y: 105.706, xText: 193.064, yText: 108.331 },
      { x: 195.743, y: 103.541, xText: 193.535, yText: 106.166 },
      { x: 196.993, y: 101.376, xText: 194.826, yText: 104.001 },
      { x: 198.243, y: 99.211, xText: 196.099, yText: 101.836 },
      { x: 199.493, y: 97.046, xText: 197.322, yText: 99.6709 },
      { x: 200.743, y: 94.881, xText: 198.418, yText: 97.5059 },
      { x: 201.993, y: 92.715, xText: 199.87, yText: 95.3403 },
      { x: 203.243, y: 90.55, xText: 200.857, yText: 93.1753 },
      { x: 204.493, y: 88.385, xText: 202.171, yText: 91.0103 },
      { x: 205.743, y: 86.22, xText: 201.734, yText: 88.8452 },
      { x: 206.993, y: 84.055, xText: 204.135, yText: 86.6802 },
      { x: 208.243, y: 81.89, xText: 204.605, yText: 84.5151 },
    ],
    dimensions: [
      { x: 162, y: 161.999, xText: 159.419, yText: 164.624 },
      { x: 166.33, y: 159.499, xText: 164.901, yText: 162.124 },
      { x: 170.66, y: 156.999, xText: 168.451, yText: 159.624 },
      { x: 174.99, y: 154.499, xText: 172.822, yText: 157.124 },
      { x: 179.32, y: 151.999, xText: 177.176, yText: 154.624 },
      { x: 183.65, y: 149.499, xText: 181.48, yText: 152.124 },
      { x: 187.98, y: 146.999, xText: 185.655, yText: 149.624 },
      { x: 192.312, y: 144.499, xText: 190.189, yText: 147.124 },
      { x: 196.642, y: 141.999, xText: 194.256, yText: 144.624 },
      { x: 200.972, y: 139.499, xText: 198.649, yText: 142.124 },
      { x: 205.302, y: 136.999, xText: 201.293, yText: 139.624 },
      { x: 209.632, y: 134.499, xText: 206.773, yText: 137.124 },
      { x: 213.962, y: 131.999, xText: 210.324, yText: 134.624 },
    ],
  },
  1: {
    competences: [
      { x: 209.491, y: 79.728, xText: 206.91, yText: 82.3525 },
      { x: 211.991, y: 75.397, xText: 210.562, yText: 78.0225 },
      { x: 214.491, y: 71.067, xText: 212.283, yText: 73.6919 },
      { x: 216.991, y: 66.737, xText: 214.824, yText: 69.3618 },
      { x: 219.491, y: 62.407, xText: 216.348, yText: 65.0317 },
      { x: 221.991, y: 58.076, xText: 219.82, yText: 60.7012 },
      { x: 224.491, y: 53.746, xText: 222.166, yText: 56.3711 },
      { x: 226.992, y: 49.416, xText: 224.869, yText: 52.041 },
      { x: 229.492, y: 45.085, xText: 227.106, yText: 47.7104 },
      { x: 231.992, y: 40.755, xText: 229.67, yText: 43.3804 },
      { x: 234.492, y: 36.425, xText: 230.483, yText: 39.0503 },
      { x: 236.992, y: 32.095, xText: 234.135, yText: 34.7197 },
      { x: 239.492, y: 27.765, xText: 235.855, yText: 30.3896 },
    ],
    vectors: [
      { x: 224.494, y: 161.998, xText: 221.914, yText: 164.623 },
      { x: 226.994, y: 161.998, xText: 225.565, yText: 164.623 },
      { x: 229.494, y: 161.998, xText: 227.285, yText: 164.623 },
      { x: 231.994, y: 161.998, xText: 229.826, yText: 164.623 },
      { x: 234.494, y: 161.998, xText: 232.35, yText: 164.623 },
      { x: 236.994, y: 161.998, xText: 234.822, yText: 164.623 },
      { x: 239.494, y: 161.998, xText: 237.168, yText: 164.623 },
      { x: 241.994, y: 161.998, xText: 239.871, yText: 164.623 },
      { x: 244.494, y: 161.998, xText: 242.109, yText: 164.623 },
      { x: 246.994, y: 161.998, xText: 244.672, yText: 164.623 },
      { x: 249.494, y: 161.998, xText: 245.485, yText: 164.623 },
      { x: 251.994, y: 161.998, xText: 249.137, yText: 164.623 },
      { x: 254.494, y: 161.998, xText: 250.857, yText: 164.623 },
    ],
    dimensions: [
      { x: 162, y: 162, xText: 159.419, yText: 164.625 },
      { x: 162, y: 167, xText: 160.571, yText: 169.625 },
      { x: 162, y: 172, xText: 159.792, yText: 174.625 },
      { x: 162, y: 177, xText: 159.833, yText: 179.625 },
      { x: 162, y: 182, xText: 159.855, yText: 184.625 },
      { x: 162, y: 187, xText: 159.829, yText: 189.625 },
      { x: 162, y: 192, xText: 159.674, yText: 194.625 },
      { x: 162, y: 197, xText: 159.877, yText: 199.625 },
      { x: 162, y: 202, xText: 159.615, yText: 204.625 },
      { x: 162, y: 207, xText: 159.678, yText: 209.625 },
      { x: 162, y: 212, xText: 157.991, yText: 214.625 },
      { x: 162, y: 217, xText: 159.142, yText: 219.625 },
      { x: 162, y: 222, xText: 158.363, yText: 224.625 },
    ],
  },
  2: {
    competences: [
      { x: 234.766, y: 100.933, xText: 232.185, yText: 103.558 },
      { x: 238.596, y: 97.719, xText: 237.167, yText: 100.344 },
      { x: 242.426, y: 94.504, xText: 240.218, yText: 97.1294 },
      { x: 246.257, y: 91.291, xText: 244.09, yText: 93.9155 },
      { x: 250.087, y: 88.077, xText: 246.941, yText: 90.7017 },
      { x: 253.917, y: 84.862, xText: 251.746, yText: 87.4873 },
      { x: 257.748, y: 81.648, xText: 255.422, yText: 84.2734 },
      { x: 261.578, y: 78.435, xText: 259.455, yText: 81.0596 },
      { x: 265.408, y: 75.22, xText: 263.023, yText: 77.8452 },
      { x: 269.238, y: 72.006, xText: 266.916, yText: 74.6313 },
      { x: 273.068, y: 68.792, xText: 269.06, yText: 71.4175 },
      { x: 276.899, y: 65.578, xText: 274.041, yText: 68.2031 },
      { x: 280.729, y: 62.364, xText: 277.092, yText: 64.9888 },
    ],
    vectors: [
      { x: 193.249, y: 216.119, xText: 190.668, yText: 218.744 },
      { x: 194.499, y: 218.284, xText: 193.07, yText: 220.909 },
      { x: 195.749, y: 220.449, xText: 193.541, yText: 223.074 },
      { x: 196.999, y: 222.614, xText: 194.832, yText: 225.239 },
      { x: 198.249, y: 224.779, xText: 196.104, yText: 227.404 },
      { x: 199.499, y: 226.944, xText: 197.328, yText: 229.569 },
      { x: 200.749, y: 229.109, xText: 198.424, yText: 231.734 },
      { x: 201.999, y: 231.274, xText: 199.877, yText: 233.899 },
      { x: 203.249, y: 233.439, xText: 200.864, yText: 236.064 },
      { x: 204.499, y: 235.604, xText: 202.178, yText: 238.23 },
      { x: 205.749, y: 237.77, xText: 201.74, yText: 240.395 },
      { x: 206.999, y: 239.935, xText: 204.141, yText: 242.56 },
      { x: 208.249, y: 242.1, xText: 204.611, yText: 244.725 },
    ],
    dimensions: [
      { x: 161.997, y: 162.012, xText: 159.416, yText: 164.636 },
      { x: 157.667, y: 159.512, xText: 156.238, yText: 162.137 },
      { x: 153.337, y: 157.012, xText: 151.128, yText: 159.636 },
      { x: 149.007, y: 154.51, xText: 146.839, yText: 157.135 },
      { x: 144.676, y: 152.01, xText: 142.531, yText: 154.635 },
      { x: 140.346, y: 149.51, xText: 138.175, yText: 152.135 },
      { x: 136.016, y: 147.011, xText: 133.69, yText: 149.636 },
      { x: 131.686, y: 144.511, xText: 129.564, yText: 147.136 },
      { x: 127.356, y: 142.011, xText: 124.971, yText: 144.636 },
      { x: 123.025, y: 139.511, xText: 120.704, yText: 142.136 },
      { x: 118.695, y: 137.011, xText: 114.687, yText: 139.636 },
      { x: 114.365, y: 134.511, xText: 111.507, yText: 137.136 },
      { x: 110.035, y: 132.011, xText: 106.398, yText: 134.636 },
    ],
  },
  3: {
    competences: [
      { x: 251.26, y: 129.504, xText: 248.68, yText: 132.129 },
      { x: 255.958, y: 127.794, xText: 254.529, yText: 130.419 },
      { x: 260.657, y: 126.083, xText: 258.449, yText: 128.708 },
      { x: 265.355, y: 124.374, xText: 263.189, yText: 126.998 },
      { x: 270.055, y: 122.663, xText: 266.91, yText: 125.288 },
      { x: 274.753, y: 120.953, xText: 272.582, yText: 123.578 },
      { x: 279.452, y: 119.243, xText: 277.127, yText: 121.868 },
      { x: 284.15, y: 117.533, xText: 282.027, yText: 120.158 },
      { x: 288.849, y: 115.823, xText: 286.464, yText: 118.448 },
      { x: 293.548, y: 114.112, xText: 291.226, yText: 116.737 },
      { x: 298.246, y: 112.402, xText: 294.237, yText: 115.027 },
      { x: 302.945, y: 110.692, xText: 300.087, yText: 113.317 },
      { x: 307.644, y: 108.982, xText: 304.006, yText: 111.607 },
    ],
    vectors: [
      { x: 130.751, y: 216.126, xText: 128.17, yText: 218.751 },
      { x: 129.501, y: 218.291, xText: 128.073, yText: 220.916 },
      { x: 128.251, y: 220.456, xText: 126.044, yText: 223.081 },
      { x: 127.002, y: 222.621, xText: 124.835, yText: 225.246 },
      { x: 125.752, y: 224.786, xText: 123.608, yText: 227.411 },
      { x: 124.502, y: 226.951, xText: 122.331, yText: 229.576 },
      { x: 123.252, y: 229.116, xText: 120.927, yText: 231.741 },
      { x: 122.001, y: 231.281, xText: 119.879, yText: 233.906 },
      { x: 120.751, y: 233.446, xText: 118.366, yText: 236.071 },
      { x: 119.501, y: 235.611, xText: 117.18, yText: 238.236 },
      { x: 118.251, y: 237.776, xText: 114.243, yText: 240.401 },
      { x: 117.001, y: 239.941, xText: 114.143, yText: 242.566 },
      { x: 115.751, y: 242.106, xText: 112.114, yText: 244.731 },
    ],
  },
  4: {
    competences: [
      { x: 256.989, y: 161.995, xText: 254.408, yText: 164.619 },
      { x: 261.989, y: 161.994, xText: 260.56, yText: 164.619 },
      { x: 266.989, y: 161.994, xText: 264.781, yText: 164.619 },
      { x: 271.99, y: 161.994, xText: 269.822, yText: 164.619 },
      { x: 276.99, y: 161.994, xText: 273.845, yText: 164.619 },
      { x: 281.99, y: 161.994, xText: 279.818, yText: 164.619 },
      { x: 286.99, y: 161.994, xText: 284.664, yText: 164.619 },
      { x: 291.99, y: 161.994, xText: 289.867, yText: 164.619 },
      { x: 296.99, y: 161.994, xText: 294.605, yText: 164.619 },
      { x: 301.99, y: 161.994, xText: 299.669, yText: 164.619 },
      { x: 306.991, y: 161.994, xText: 302.982, yText: 164.619 },
      { x: 311.991, y: 161.994, xText: 309.133, yText: 164.619 },
      { x: 316.991, y: 161.994, xText: 313.353, yText: 164.619 },
    ],
    vectors: [
      { x: 99.5, y: 162, xText: 96.9194, yText: 164.625 },
      { x: 97, y: 162, xText: 95.5713, yText: 164.625 },
      { x: 94.5, y: 162.001, xText: 92.2915, yText: 164.625 },
      { x: 92, y: 161.999, xText: 89.8325, yText: 164.625 },
      { x: 89.5, y: 162, xText: 87.355, yText: 164.625 },
      { x: 87, y: 162, xText: 84.8286, yText: 164.625 },
      { x: 84.5, y: 162, xText: 82.1743, yText: 164.625 },
      { x: 82, y: 162, xText: 79.8774, yText: 164.625 },
      { x: 79.5, y: 162, xText: 77.1152, yText: 164.625 },
      { x: 77, y: 162, xText: 74.6782, yText: 164.625 },
      { x: 74.5, y: 162, xText: 70.4912, yText: 164.625 },
      { x: 72, y: 162, xText: 69.1421, yText: 164.625 },
      { x: 69.5, y: 162, xText: 65.8628, yText: 164.625 },
    ],
  },
  5: {
    competences: [
      { x: 251.263, y: 194.486, xText: 248.682, yText: 197.112 },
      { x: 255.961, y: 196.196, xText: 254.532, yText: 198.821 },
      { x: 260.66, y: 197.906, xText: 258.451, yText: 200.531 },
      { x: 265.358, y: 199.617, xText: 263.19, yText: 202.242 },
      { x: 270.057, y: 201.327, xText: 266.911, yText: 203.952 },
      { x: 274.755, y: 203.037, xText: 272.584, yText: 205.662 },
      { x: 279.453, y: 204.748, xText: 277.128, yText: 207.373 },
      { x: 284.152, y: 206.458, xText: 282.029, yText: 209.083 },
      { x: 288.851, y: 208.168, xText: 286.467, yText: 210.793 },
      { x: 293.549, y: 209.878, xText: 291.228, yText: 212.503 },
      { x: 298.248, y: 211.588, xText: 294.238, yText: 214.213 },
      { x: 302.946, y: 213.299, xText: 300.088, yText: 215.924 },
      { x: 307.645, y: 215.009, xText: 304.008, yText: 217.634 },
    ],
    vectors: [
      { x: 130.745, y: 107.879, xText: 128.165, yText: 110.504 },
      { x: 129.495, y: 105.714, xText: 128.066, yText: 108.339 },
      { x: 128.245, y: 103.55, xText: 126.037, yText: 106.174 },
      { x: 126.995, y: 101.383, xText: 124.828, yText: 104.008 },
      { x: 125.745, y: 99.218, xText: 123.6, yText: 101.843 },
      { x: 124.495, y: 97.053, xText: 122.324, yText: 99.6777 },
      { x: 123.245, y: 94.888, xText: 120.919, yText: 97.5127 },
      { x: 121.995, y: 92.723, xText: 119.873, yText: 95.3481 },
      { x: 120.745, y: 90.558, xText: 118.36, yText: 93.1831 },
      { x: 119.495, y: 88.393, xText: 117.173, yText: 91.0181 },
      { x: 118.245, y: 86.229, xText: 114.236, yText: 88.8535 },
      { x: 116.995, y: 84.063, xText: 114.137, yText: 86.6885 },
      { x: 115.745, y: 81.898, xText: 112.108, yText: 84.5234 },
    ],
  },
  6: {
    competences: [
      { x: 234.77, y: 223.06, xText: 232.189, yText: 225.685 },
      { x: 238.6, y: 226.273, xText: 237.171, yText: 228.898 },
      { x: 242.43, y: 229.487, xText: 240.222, yText: 232.112 },
      { x: 246.261, y: 232.701, xText: 244.093, yText: 235.326 },
      { x: 250.091, y: 235.915, xText: 246.945, yText: 238.541 },
      { x: 253.921, y: 239.129, xText: 251.75, yText: 241.754 },
      { x: 257.751, y: 242.344, xText: 255.426, yText: 244.969 },
      { x: 261.581, y: 245.558, xText: 259.459, yText: 248.182 },
      { x: 265.411, y: 248.771, xText: 263.027, yText: 251.396 },
      { x: 269.242, y: 251.985, xText: 266.92, yText: 254.61 },
      { x: 273.072, y: 255.199, xText: 269.062, yText: 257.824 },
      { x: 276.902, y: 258.413, xText: 274.045, yText: 261.038 },
      { x: 280.732, y: 261.627, xText: 277.096, yText: 264.252 },
    ],
  },
  7: {
    competences: [
      { x: 209.497, y: 244.266, xText: 206.916, yText: 246.891 },
      { x: 211.997, y: 248.596, xText: 210.568, yText: 251.221 },
      { x: 214.497, y: 252.926, xText: 212.289, yText: 255.551 },
      { x: 216.997, y: 257.256, xText: 214.83, yText: 259.881 },
      { x: 219.497, y: 261.587, xText: 216.352, yText: 264.211 },
      { x: 221.997, y: 265.917, xText: 219.826, yText: 268.542 },
      { x: 224.497, y: 270.247, xText: 222.172, yText: 272.872 },
      { x: 226.998, y: 274.577, xText: 224.875, yText: 277.202 },
      { x: 229.498, y: 278.907, xText: 227.113, yText: 281.533 },
      { x: 231.998, y: 283.237, xText: 229.676, yText: 285.863 },
      { x: 234.498, y: 287.568, xText: 230.489, yText: 290.193 },
      { x: 236.998, y: 291.898, xText: 234.141, yText: 294.523 },
      { x: 239.498, y: 296.229, xText: 235.861, yText: 298.853 },
    ],
  },
  8: {
    competences: [
      { x: 178.494, y: 255.549, xText: 175.914, yText: 258.174 },
      { x: 179.362, y: 260.473, xText: 177.934, yText: 263.098 },
      { x: 180.23, y: 265.397, xText: 178.023, yText: 268.022 },
      { x: 181.1, y: 270.321, xText: 178.932, yText: 272.946 },
      { x: 181.968, y: 275.245, xText: 178.822, yText: 277.871 },
      { x: 182.836, y: 280.17, xText: 180.664, yText: 282.795 },
      { x: 183.704, y: 285.094, xText: 181.379, yText: 287.719 },
      { x: 184.572, y: 290.018, xText: 182.449, yText: 292.643 },
      { x: 185.44, y: 294.942, xText: 183.057, yText: 297.566 },
      { x: 186.31, y: 299.866, xText: 183.987, yText: 302.491 },
      { x: 187.178, y: 304.79, xText: 183.168, yText: 307.416 },
      { x: 188.046, y: 309.715, xText: 185.188, yText: 312.34 },
      { x: 188.914, y: 314.639, xText: 185.276, yText: 317.264 },
    ],
  },
  9: {
    competences: [
      { x: 145.501, y: 255.55, xText: 142.921, yText: 258.175 },
      { x: 144.633, y: 260.474, xText: 143.206, yText: 263.099 },
      { x: 143.766, y: 265.398, xText: 141.558, yText: 268.023 },
      { x: 142.898, y: 270.322, xText: 140.731, yText: 272.947 },
      { x: 142.03, y: 275.246, xText: 138.885, yText: 277.871 },
      { x: 141.161, y: 280.17, xText: 138.991, yText: 282.795 },
      { x: 140.293, y: 285.094, xText: 137.968, yText: 287.719 },
      { x: 139.424, y: 290.019, xText: 137.301, yText: 292.644 },
      { x: 138.555, y: 294.942, xText: 136.171, yText: 297.567 },
      { x: 137.688, y: 299.866, xText: 135.366, yText: 302.491 },
      { x: 136.819, y: 304.791, xText: 132.811, yText: 307.416 },
      { x: 135.951, y: 309.715, xText: 133.093, yText: 312.34 },
      { x: 135.083, y: 314.639, xText: 131.445, yText: 317.264 },
    ],
  },
  10: {
    competences: [
      { x: 114.498, y: 244.268, xText: 111.917, yText: 246.893 },
      { x: 111.998, y: 248.598, xText: 110.57, yText: 251.223 },
      { x: 109.498, y: 252.928, xText: 107.29, yText: 255.553 },
      { x: 106.999, y: 257.258, xText: 104.832, yText: 259.883 },
      { x: 104.499, y: 261.588, xText: 102, yText: 264.213 },
      { x: 101.999, y: 265.918, xText: 99.8276, yText: 268.543 },
      { x: 99.499, y: 270.249, xText: 97.1733, yText: 272.873 },
      { x: 96.998, y: 274.579, xText: 94.8755, yText: 277.203 },
      { x: 94.497, y: 278.909, xText: 92.1128, yText: 281.533 },
      { x: 91.998, y: 283.239, xText: 89.6763, yText: 285.864 },
      { x: 89.498, y: 287.569, xText: 85.4893, yText: 290.194 },
      { x: 86.998, y: 291.899, xText: 84.1396, yText: 294.524 },
      { x: 84.498, y: 296.229, xText: 80.8604, yText: 298.854 },
    ],
  },
  11: {
    competences: [
      { x: 89.225, y: 223.063, xText: 86.644, yText: 225.689 },
      { x: 85.394, y: 226.277, xText: 83.9663, yText: 228.902 },
      { x: 81.565, y: 229.491, xText: 79.3574, yText: 232.116 },
      { x: 77.735, y: 232.705, xText: 75.5684, yText: 235.33 },
      { x: 73.905, y: 235.919, xText: 70.7603, yText: 238.545 },
      { x: 70.075, y: 239.133, xText: 67.9038, yText: 241.758 },
      { x: 66.244, y: 242.348, xText: 63.9189, yText: 244.973 },
      { x: 62.413, y: 245.562, xText: 60.2905, yText: 248.186 },
      { x: 58.583, y: 248.775, xText: 56.1982, yText: 251.4 },
      { x: 54.753, y: 251.989, xText: 52.4312, yText: 254.614 },
      { x: 50.922, y: 255.203, xText: 46.9136, yText: 257.828 },
      { x: 47.092, y: 258.417, xText: 44.2344, yText: 261.042 },
      { x: 43.262, y: 261.631, xText: 39.6245, yText: 264.256 },
    ],
  },
  12: {
    competences: [
      { x: 72.729, y: 194.492, xText: 70.1484, yText: 197.117 },
      { x: 68.03, y: 196.201, xText: 66.6016, yText: 198.826 },
      { x: 63.332, y: 197.912, xText: 61.1235, yText: 200.536 },
      { x: 58.634, y: 199.621, xText: 56.4663, yText: 202.247 },
      { x: 53.935, y: 201.333, xText: 50.79, yText: 203.958 },
      { x: 49.236, y: 203.042, xText: 47.0649, yText: 205.666 },
      { x: 44.538, y: 204.751, xText: 42.2124, yText: 207.376 },
      { x: 39.84, y: 206.46, xText: 37.7173, yText: 209.086 },
      { x: 35.141, y: 208.169, xText: 32.7568, yText: 210.794 },
      { x: 30.442, y: 209.88, xText: 28.1201, yText: 212.506 },
      { x: 25.744, y: 211.592, xText: 21.7354, yText: 214.217 },
      { x: 21.046, y: 213.303, xText: 18.1885, yText: 215.928 },
      { x: 16.347, y: 215.014, xText: 12.71, yText: 217.639 },
    ],
  },
  13: {
    competences: [
      { x: 67, y: 162.001, xText: 64.4194, yText: 164.625 },
      { x: 62, y: 162.001, xText: 60.5713, yText: 164.625 },
      { x: 57, y: 162.002, xText: 54.7915, yText: 164.625 },
      { x: 52, y: 162, xText: 49.8325, yText: 164.625 },
      { x: 47, y: 162.001, xText: 43.855, yText: 164.625 },
      { x: 42, y: 162.001, xText: 39.8286, yText: 164.625 },
      { x: 37, y: 162.001, xText: 34.6743, yText: 164.625 },
      { x: 32, y: 162.001, xText: 29.8779, yText: 164.625 },
      { x: 27, y: 162, xText: 24.6152, yText: 164.625 },
      { x: 22, y: 162, xText: 19.6787, yText: 164.625 },
      { x: 17, y: 162, xText: 12.9912, yText: 164.625 },
      { x: 12, y: 162, xText: 9.1416, yText: 164.625 },
      { x: 7, y: 162, xText: 3.3623, yText: 164.625 },
    ],
  },
  14: {
    competences: [
      { x: 72.727, y: 129.509, xText: 70.146, yText: 132.133 },
      { x: 68.028, y: 127.799, xText: 66.5991, yText: 130.424 },
      { x: 63.33, y: 126.089, xText: 61.1211, yText: 128.713 },
      { x: 58.631, y: 124.377, xText: 56.4634, yText: 127.002 },
      { x: 53.932, y: 122.667, xText: 50.7871, yText: 125.292 },
      { x: 49.234, y: 120.957, xText: 47.0625, yText: 123.582 },
      { x: 44.535, y: 119.247, xText: 42.2095, yText: 121.872 },
      { x: 39.836, y: 117.537, xText: 37.7139, yText: 120.162 },
      { x: 35.138, y: 115.827, xText: 32.7529, yText: 118.452 },
      { x: 30.439, y: 114.117, xText: 28.1182, yText: 116.742 },
      { x: 25.741, y: 112.407, xText: 21.7314, yText: 115.032 },
      { x: 21.042, y: 110.697, xText: 18.1846, yText: 113.322 },
      { x: 16.344, y: 108.987, xText: 12.7061, yText: 111.612 },
    ],
  },
  15: {
    competences: [
      { x: 89.221, y: 100.936, xText: 86.6406, yText: 103.561 },
      { x: 85.391, y: 97.722, xText: 83.9624, yText: 100.347 },
      { x: 81.561, y: 94.508, xText: 79.3521, yText: 97.1323 },
      { x: 77.73, y: 91.292, xText: 75.563, yText: 93.918 },
      { x: 73.9, y: 88.079, xText: 70.7549, yText: 90.7036 },
      { x: 70.07, y: 84.865, xText: 67.8984, yText: 87.4897 },
      { x: 66.239, y: 81.651, xText: 63.9136, yText: 84.2759 },
      { x: 62.409, y: 78.437, xText: 60.2866, yText: 81.062 },
      { x: 58.579, y: 75.223, xText: 56.1943, yText: 77.8481 },
      { x: 54.749, y: 72.009, xText: 52.4268, yText: 74.6343 },
      { x: 50.918, y: 68.795, xText: 46.9097, yText: 71.4204 },
      { x: 47.088, y: 65.582, xText: 44.23, yText: 68.2065 },
      { x: 43.258, y: 62.368, xText: 39.6206, yText: 64.9927 },
    ],
  },
  16: {
    competences: [
      { x: 114.493, y: 79.73, xText: 111.912, yText: 82.355 },
      { x: 111.993, y: 75.4, xText: 110.564, yText: 78.0254 },
      { x: 109.493, y: 71.07, xText: 107.284, yText: 73.6943 },
      { x: 106.993, y: 66.738, xText: 104.825, yText: 69.3638 },
      { x: 104.493, y: 62.408, xText: 101.348, yText: 65.0332 },
      { x: 101.993, y: 58.078, xText: 99.8213, yText: 60.7031 },
      { x: 99.492, y: 53.748, xText: 97.1665, yText: 56.373 },
      { x: 96.992, y: 49.417, xText: 94.8696, yText: 52.0425 },
      { x: 94.492, y: 45.087, xText: 92.1074, yText: 47.7124 },
      { x: 91.992, y: 40.757, xText: 89.6704, yText: 43.3823 },
      { x: 89.492, y: 36.427, xText: 85.4834, yText: 39.0522 },
      { x: 86.992, y: 32.097, xText: 84.1343, yText: 34.7222 },
      { x: 84.492, y: 27.767, xText: 80.855, yText: 30.3921 },
    ],
  },
  17: {
    competences: [
      { x: 145.495, y: 68.446, xText: 142.915, yText: 71.0703 },
      { x: 144.627, y: 63.522, xText: 143.198, yText: 66.147 },
      { x: 143.759, y: 58.598, xText: 141.55, yText: 61.2217 },
      { x: 142.89, y: 53.672, xText: 140.723, yText: 56.2974 },
      { x: 142.022, y: 48.749, xText: 138.877, yText: 51.373 },
      { x: 141.154, y: 43.824, xText: 138.982, yText: 46.4487 },
      { x: 140.285, y: 38.9, xText: 137.96, yText: 41.5249 },
      { x: 139.417, y: 33.977, xText: 137.294, yText: 36.6011 },
      { x: 138.549, y: 29.052, xText: 136.164, yText: 31.6768 },
      { x: 137.681, y: 24.128, xText: 135.359, yText: 26.7529 },
      { x: 136.812, y: 19.205, xText: 132.804, yText: 21.8291 },
      { x: 135.944, y: 14.28, xText: 133.086, yText: 16.9048 },
      { x: 135.076, y: 9.356, xText: 131.439, yText: 11.9805 },
    ],
  },
} as const

export const coordinatesMedium = [
  {
    'blue-yellow': { x: 161.994, y: 67 },
    'blue-green': { x: 244.273, y: 209.506 },
    'green-yellow': { x: 79.73, y: 209.505 },
  },
  {
    'blue-yellow': { x: 161.994, y: 61.9995 },
    'blue-green': { x: 248.604, y: 212.006 },
    'green-yellow': { x: 75.4, y: 212.005 },
  },
  {
    'blue-yellow': { x: 161.994, y: 56.9985 },
    'blue-green': { x: 252.935, y: 214.507 },
    'green-yellow': { x: 71.07, y: 214.506 },
  },
  {
    'blue-yellow': { x: 161.994, y: 51.9971 },
    'blue-green': { x: 257.266, y: 217.007 },
    'green-yellow': { x: 66.74, y: 217.006 },
  },
  {
    'blue-yellow': { x: 161.994, y: 46.9966 },
    'blue-green': { x: 261.596, y: 219.507 },
    'green-yellow': { x: 62.409, y: 219.506 },
  },
  {
    'blue-yellow': { x: 161.994, y: 41.9961 },
    'blue-green': { x: 265.926, y: 222.008 },
    'green-yellow': { x: 58.079, y: 222.006 },
  },
  {
    'blue-yellow': { x: 161.994, y: 36.9956 },
    'blue-green': { x: 270.257, y: 224.508 },
    'green-yellow': { x: 53.748, y: 224.506 },
  },
  {
    'blue-yellow': { x: 161.994, y: 31.9951 },
    'blue-green': { x: 274.588, y: 227.008 },
    'green-yellow': { x: 49.417, y: 227.007 },
  },
  {
    'blue-yellow': { x: 161.994, y: 26.9946 },
    'blue-green': { x: 278.918, y: 229.509 },
    'green-yellow': { x: 45.086, y: 229.507 },
  },
  {
    'blue-yellow': { x: 161.994, y: 21.9941 },
    'blue-green': { x: 283.248, y: 232.009 },
    'green-yellow': { x: 40.755, y: 232.007 },
  },
  {
    'blue-yellow': { x: 161.994, y: 16.9941 },
    'blue-green': { x: 287.579, y: 234.509 },
    'green-yellow': { x: 36.425, y: 234.508 },
  },
  {
    'blue-yellow': { x: 161.994, y: 11.9937 },
    'blue-green': { x: 291.91, y: 237.01 },
    'green-yellow': { x: 32.094, y: 237.008 },
  },
  {
    'blue-yellow': { x: 161.994, y: 6.9932 },
    'blue-green': { x: 296.24, y: 239.51 },
    'green-yellow': { x: 27.763, y: 239.508 },
  },
] as const

export const circle = [
  {
    type: 'competences',
    list: [
      'M215.02,16.31l-0.01,0.03L194.5,72.7 C184.36,69.01,173.41,67,162,67v-0.01L161.99,7C180.62,7,198.48,10.29,215.02,16.31z',
      'M261.63,43.26l-38.57,45.96c-8.399-7.06-18.05-12.69-28.56-16.52 l20.51-56.36l0.01-0.03C232.17,22.56,247.91,31.74,261.63,43.26z',
      'M296.25,84.49l-0.02,0.01l-51.95,29.99 c-5.561-9.62-12.761-18.16-21.221-25.27l38.57-45.96C275.43,54.85,287.18,68.8,296.25,84.49z',
      'M314.67,135.07l-0.03,0.01L255.57,145.5 c-1.95-11.13-5.83-21.58-11.29-31.01l51.95-29.99l0.02-0.01C305.16,99.87,311.49,116.93,314.67,135.07z',
      'M314.67,135.07c1.53,8.74,2.33,17.74,2.33,26.92 c0,9.18-0.8,18.18-2.33,26.92h-0.03l-59.069-10.42c0.939-5.36,1.43-10.87,1.43-16.5c0-5.63-0.49-11.14-1.43-16.49l59.069-10.42 L314.67,135.07z',
      'M314.64,188.91h0.03c-3.18,18.149-9.51,35.21-18.42,50.6 l-0.02-0.01l-51.95-30c5.46-9.43,9.34-19.89,11.29-31.01L314.64,188.91z',
      'M296.23,239.5l0.02,0.01c-9.08,15.69-20.83,29.641-34.62,41.23 l-38.57-45.96l-0.01-0.011c8.46-7.1,15.67-15.649,21.23-25.27L296.23,239.5z',
      'M223.06,234.78l38.57,45.96c-13.72,11.52-29.46,20.7-46.61,26.939 l-0.01-0.029l-20.51-56.36c10.51-3.83,20.15-9.46,28.55-16.521L223.06,234.78z',
      'M215.01,307.65l0.01,0.029C198.48,313.71,180.62,317,161.99,317 v-60c11.42,0,22.359-2.02,32.51-5.71L215.01,307.65z',
      'M161.99,257v60c-18.62,0-36.48-3.29-53.02-9.31l0.01-0.04 l20.51-56.36C139.63,254.98,150.57,257,161.99,257z',
      'M129.49,251.29l-20.51,56.36l-0.01,0.04 c-17.16-6.24-32.9-15.431-46.61-26.96l38.56-45.961l0.01-0.01C109.33,241.83,118.98,247.46,129.49,251.29z',
      'M100.93,234.76l-0.01,0.01L62.36,280.73 c-13.8-11.591-25.54-25.54-34.61-41.23l0.01-0.01l51.95-29.99C85.28,219.12,92.48,227.67,100.93,234.76z',
      'M79.71,209.5l-51.95,29.99l-0.01,0.01 c-8.91-15.39-15.24-32.45-18.42-50.59h0.02l59.08-10.42C70.37,189.61,74.26,200.07,79.71,209.5z',
      'M9.35,135.08l59.08,10.42c-0.94,5.35-1.43,10.86-1.43,16.49 c0,5.63,0.49,11.14,1.43,16.5L9.35,188.91H9.33C7.8,180.17,7,171.17,7,161.99c0-9.18,0.8-18.17,2.33-26.91H9.35z',
      'M27.76,84.49l51.95,30c-5.46,9.43-9.34,19.88-11.28,31.01 L9.35,135.08H9.33c3.18-18.15,9.51-35.21,18.42-50.6L27.76,84.49z',
      'M62.37,43.26l38.56,45.96c-8.45,7.1-15.65,15.65-21.22,25.27 l-51.95-30l-0.01-0.01C36.82,68.79,48.57,54.84,62.37,43.26z',
      'M108.98,16.34l20.51,56.36c-10.51,3.83-20.16,9.46-28.56,16.52 L62.37,43.26c13.71-11.52,29.45-20.71,46.6-26.95L108.98,16.34z',
      'M162,66.99V67h-0.01c-11.42,0-22.36,2.01-32.5,5.7l-20.51-56.36 l-0.01-0.03C125.51,10.29,143.37,7,161.99,7L162,66.99z',
    ],
  },
  {
    type: 'vectors',
    list: [
      'M194.5,72.7c10.51,3.83,20.16,9.46,28.56,16.52 c8.46,7.11,15.66,15.65,21.221,25.27l-0.011,0.01l-30.3,17.49C203.59,114.06,184.2,102,162,102V67 C173.41,67,184.36,69.01,194.5,72.7z',
      'M244.27,114.5l0.011-0.01c5.46,9.43,9.34,19.88,11.29,31.01 c0.939,5.35,1.43,10.86,1.43,16.49c0,5.63-0.49,11.14-1.43,16.5c-1.95,11.12-5.83,21.58-11.29,31.01h-0.011L213.96,192 c5.11-8.83,8.04-19.08,8.04-30.01c0-10.93-2.93-21.18-8.03-30L244.27,114.5z',
      'M244.27,209.5h0.011c-5.561,9.62-12.771,18.17-21.23,25.27 c-8.399,7.061-18.04,12.69-28.55,16.521c-10.15,3.69-21.09,5.71-32.51,5.71v-35c22.21,0,41.6-12.07,51.97-30L244.27,209.5z',
      'M110.04,192c10.36,17.93,29.75,30,51.95,30v35 c-11.42,0-22.36-2.02-32.5-5.71c-10.51-3.83-20.16-9.46-28.56-16.53c-8.45-7.09-15.65-15.64-21.22-25.26h0.01l30.31-17.5H110.04z',
      'M79.73,114.49l30.3,17.5c-5.1,8.82-8.03,19.07-8.03,30 c0,10.93,2.93,21.18,8.03,30.01l-30.31,17.5h-0.01c-5.45-9.43-9.34-19.89-11.28-31.01c-0.94-5.36-1.43-10.87-1.43-16.5 c0-5.63,0.49-11.14,1.43-16.49c1.94-11.13,5.82-21.58,11.28-31.01h0.01H79.73z',
      'M129.49,72.7c10.14-3.69,21.08-5.7,32.5-5.7H162v35h-0.01 c-22.2,0-41.59,12.06-51.95,29.99h-0.01l-30.3-17.5h-0.01h-0.01c5.57-9.62,12.77-18.17,21.22-25.27 C109.33,82.16,118.98,76.53,129.49,72.7z',
    ],
  },
  {
    type: 'dimensions',
    list: [
      'M213.97,131.99c5.101,8.82,8.03,19.07,8.03,30 c0,10.93-2.93,21.18-8.04,30.01L162,162v-60C184.2,102,203.59,114.06,213.97,131.99z',
      'M162,162l51.96,30c-10.37,17.93-29.76,30-51.97,30 c-22.2,0-41.59-12.07-51.95-30L162,162z',
      'M162,102v60l-51.96,30h-0.01c-5.1-8.83-8.03-19.08-8.03-30.01 c0-10.93,2.93-21.18,8.03-30h0.01C120.4,114.06,139.79,102,161.99,102H162z',
    ],
  },
] as const

/**
 * The ring geometry of `circle`, pre-joined into ONE `d` per ring type, and one for all three.
 *
 * The radar draws those 27 segments three times: per-segment in `Base` (each carries its own colour, so
 * those stay separate), and with IDENTICAL attributes in `Lines` and `BaseHover` — 52 elements painting
 * as 4. An SVG `d` may hold any number of closed subpaths, and the segments never overlap, so fill-rule
 * is not in play and the picture is byte-for-byte the same.
 */
export const circleByType = circle.map((ring) => ({
  type: ring.type,
  d: ring.list.join(' '),
}))

/** Every ring segment as a single `d`. For layers that style all 27 identically. */
export const circleAll = circle.map((ring) => ring.list.join(' ')).join(' ')
